// extracted by mini-css-extract-plugin
export default {"Row":"SaleRow_Row__BgL3p"};